let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jl5nQ")).then(() => parcelRequire('l1aa7'));